import Icon from '../components/Icon.vue'

Icon.register({
  'user-friends': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M192 256c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112zM268.8 288c63.6 0 115.2 51.6 115.2 115.2v28.8c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-28.8c0-63.6 51.6-115.2 115.2-115.2h8.3c20.9 10 43.9 16 68.5 16s47.7-6 68.5-16h8.3zM480 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM528 288c61.9 0 112 50.1 112 112 0 26.5-21.5 48-48 48h-176.6c0.1-2.1 0.6-4.2 0.6-6.4v-38.4c0-38.6-15.3-73.5-39.7-99.8 16.5-9.5 35.3-15.4 55.7-15.4h3.8c13.9 4.8 28.6 8 44.2 8s30.3-3.2 44.2-8h3.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-friends.js
// module id = 2064
// module chunks = 0